import { AssistanceSearchResponse } from '@shared/travel-assistance/entities/booking-assistance';

export const assistanceFeatureName = 'assistanceModuleState';

export type UiAssistanceState = Readonly<{
  isLoadingAssistanceSearch: boolean,
  showAssistanceInfo: boolean,
  showAssistanceDetails: boolean,
  isErrorAssistanceSearch: boolean,
  isErrorAssistanceBook: boolean,
  isLoadingAssistanceBook: boolean,
  isLoadingAssistanceCancellation: boolean,
  isLoadingConvertPdf: boolean,
  enabledForcedSelection: boolean,
}>;

export type AssistanceModuleState = Readonly<{
  assistanceSearchInfo: AssistanceSearchResponse,
  assistanceConvertPdf: string,
  ui: UiAssistanceState
}>;
